import React from 'react';
import { InputWrapper } from './styles';
import { useTagSearchResults } from '@hooks/features/useStockSearch';
import { ModeContext } from '@/contexts/ModeContext';
import { SelectableTagResults } from './SelectableTagResults';
import { useBlurAction } from '@hooks/function/useBlurAction';

export const TagSearchInput = ({ forwardRef, enableCreateTag, onAddTag, placeholder, showCompanyTags }) => {
  const modeContext = React.useContext(ModeContext);
  // When the caller explicitly wants company tags (e.g. the company/tags doc-select mode),
  // force it on regardless of ModeContext, which isn't always provided in the modal subtree.
  const searchOptions = showCompanyTags ? { ...modeContext, showCompanyTags: true } : modeContext;

  const [textInputHasFocus, setTextInputHasFocus] = React.useState(false);

  const [textInputValue, setTextInputValue] = React.useState('');
  const [isQuerying, selectableTags, activeQuery] = useTagSearchResults(textInputValue, searchOptions);

  const showTagSearchResults = textInputHasFocus && activeQuery === textInputValue;

  const { queueDelayedBlur, clearDelayedBlur } = useBlurAction();

  const handleTextChange = (e) => {
    const value = e.target.value;
    if (value === ' ' && textInputValue === '') {
      return;
    }
    setTextInputValue(value);
  };

  const handleAddTag = (tag) => {
    onAddTag(tag);
    setTextInputValue('');
    forwardRef?.current?.focus();
  };

  const onTextInputFocus = () => {
    setTextInputHasFocus(true);
    clearDelayedBlur();
  };

  const onTextInputBlur = () => {
    queueDelayedBlur(() => setTextInputHasFocus(false));
  };

  return (
    <InputWrapper>
      <input
        ref={forwardRef}
        type="text"
        placeholder={placeholder || ''}
        onChange={handleTextChange}
        value={textInputValue}
        onFocus={onTextInputFocus}
        onBlur={onTextInputBlur}
      />
      {showTagSearchResults && (
        <SelectableTagResults
          query={activeQuery}
          isQuerying={isQuerying}
          results={selectableTags}
          onSelectTag={handleAddTag}
          enableCreateTag={enableCreateTag}
        />
      )}
    </InputWrapper>
  );
};
